// TODO: Move all icons to separate files
// Use webpack `raw-loader` for this
export const closeFillCircle = {
    viewBox: '0 0 24 24',
    svg: `<path d="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,
        6.48 6.48,2 12,2 Z M17,8.35166094 L15.6483391,7 L12,10.6483391 L8.35166094,7 L7,
        8.35166094 L10.6483391,12 L7,15.6483391 L8.35166094,17 L12,13.3516609 L15.6483391,17 L17,
        15.6483391 L13.3516609,12 L17,8.35166094 Z"/>`
};
export const dropDown = {
    viewBox: '0 0 386.257 386.257',
    svg: '<polygon points="0,96.879 193.129,289.379 386.257,96.879 "/>'
};
export const star = {
    viewBox: '0 0 24 24',
    classes: [],
    svg: `<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>`
};
export const close = {
    viewBox: '0 0 24 24',
    classes: [],
    svg: `<polygon points="20 5.62199313 13.6219931 12 20 18.3780069 18.3780069 20 12 13.6219931
            5.62199313 20 4 18.3780069 10.3780069 12 4 5.62199313 5.62199313 4 12 10.3780069 18.3780069 4"></polygon>`
};
export const previous = {
    viewBox: '0 0 24 24',
    svg: `<path d="M15.41,16.59L10.83,12l4.58-4.59L14,6l-6,6l6,6L15.41,16.59z"/>
        <path fill="none" d="M0,0h24v24H0V0z"/>`
};
export const next = {
    viewBox: '0 0 24 24',
    svg: `<path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z"/>
        <path fill="none" d="M0,0h24v24H0V0z"/>`
};
export const check = {
    viewBox: '0 0 24 24',
    classes: [],
    svg: `<path fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>`
};
export const clear = {
    viewBox: '0 0 24 24',
    svg: `<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        <path d="M0 0h24v24H0z" fill="none"/>`
};
export const file = {
    viewBox: '0 0 24 24',
    classes: [],
    svg: `<path d="M14,2 L6,2 C4.9,2 4.01,2.9 4.01,4 L4,20 C4,21.1 4.89,22 5.99,22 L18,22 C19.1,22 20,21.1 20,
        20 L20,8 L14,2 L14,2 Z M16,18 L8,18 L8,16 L16,16 L16,18 L16,18 Z M16,14 L8,14 L8,12 L16,12 L16,14 L16,
        14 Z M13,9 L13,3.5 L18.5,9 L13,9 L13,9 Z"/>`
};
export const errorOutline = {
    viewBox: '0 0 24 24',
    svg: `<path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52
        22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path fill="none" d="M0 0h24v24H0V0z"/>`
};
export const event = {
    viewBox: '0 0 24 24',
    svg: `<path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1
        0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
    `
};
export const helpFill = {
    viewBox: '0 0 24 24',
    svg: `<path d="M0 0h24v24H0z" fill="none"/>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13
    15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21
    1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>`
};
export const helpOutline = {
    viewBox: '0 0 24 24',
    svg: `<path d="M0 0h24v24H0z" fill="none"/>
    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59
    8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
    `
};
export const moreAction = {
    viewBox: '0 0 24 24',
    svg: `<path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2
            2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
    `
};
export const microphone = {
    viewBox: '0 0 30 30',
    svg: `<path fill="#888888"
        d="M22.1198454,14.352086 L24.375,14.352086 C24.375,15.8270196 24.0098834,17.2176504
        23.2796392,18.5240202 C22.5708727,19.7671786 21.5990182,20.8048842 20.3640464,21.6371681
        C19.1290746,22.4694521 17.7813647,22.9804036 16.3208763,23.1700379 L16.3208763,27.5
        L13.6791237,27.5 L13.6791237,23.1700379 C12.2186353,22.9804036 10.8709254,22.4694521
        9.63595361,21.6371681 C8.4009818,20.8048842 7.42912726,19.7671786 6.72036082,18.5240202
        C5.99011662,17.2176504 5.625,15.8270196 5.625,14.352086 L7.88015464,14.352086 C7.88015464,
        15.6373853 8.22379381,16.7962443 8.91108247,17.8286979 C9.55541559,18.8190104 10.4198829,
        19.5986065 11.5045103,20.1675095 C12.5891377,20.7364125 13.7542893,21.0208597 15,21.0208597
        C16.2457107,21.0208597 17.4108623,20.7364125 18.4954897,20.1675095 C19.5801171,19.5986065
        20.4445844,18.8190104 21.0889175,17.8286979 C21.7762062,16.7962443 22.1198454,15.6373853
        22.1198454,14.352086 Z M15,18.3027813 C14.2912336,18.3027813 13.6254327,18.1236849 13.0025773,
        17.7654867 C12.379722,17.4072886 11.8857407,16.9226748 11.5206186,16.3116308 C11.1554965,
        15.7005869 10.9729381,15.0474118 10.9729381,14.352086 L10.9729381,6.45069532 C10.9729381,
        5.75536947 11.1554965,5.10219437 11.5206186,4.49115044 C11.8857407,3.88010651 12.379722,
        3.39549273 13.0025773,3.03729456 C13.6254327,2.6790964 14.2912336,2.5 15,2.5 C15.7087664,
        2.5 16.3745673,2.6790964 16.9974227,3.03729456 C17.620278,3.39549273 18.1142593,3.88010651
        18.4793814,4.49115044 C18.8445035,5.10219437 19.0270619,5.75536947 19.0270619,6.45069532
        L19.0270619,14.352086 C19.0270619,15.0474118 18.8445035,15.7005869 18.4793814,16.3116308
        C18.1142593,16.9226748 17.620278,17.4072886 16.9974227,17.7654867 C16.3745673,18.1236849
        15.7087664,18.3027813 15,18.3027813 Z">
    </path>`
};
export const playerNext = {
    viewBox: '0 0 306 306',
    svg: `<path d="M0,306l216.75-153L0,0V306z M255,0v306h51V0H255z"/>`
};
export const playerPrevious = {
    viewBox: '0 0 42 42',
    svg: `<path d="M35.965,0.114c-0.329-0.171-0.726-0.148-1.033,0.063L7.5,19.095V1c0-0.553-0.448-1-1-1s-1,0.447-1,1v40c0,0.553,0.448,1,1,1
        s1-0.447,1-1V22.905l27.432,18.919C35.103,41.94,35.301,42,35.5,42c0.159,0,0.319-0.038,0.465-0.114
        C36.294,41.713,36.5,41.372,36.5,41V1C36.5,0.628,36.294,0.287,35.965,0.114z"/>`
};
export const playerPause = {
    viewBox: '0 0 365 365',
    svg: ` <rect x="74.5" width="73" height="365"/>
        <rect x="217.5" width="73" height="365"/>`
};
export const playerFullscreen = {
    viewBox: '0 0 304 304',
    svg: `<path style="fill:#010002;" d="M250.197,228.441H54.391c-2.91,0-5.684-0.598-8.224-1.637l-23.769,23.769
            c8.991,6.57,20.027,10.503,31.993,10.503h195.806c12.575,0,24.139-4.329,33.358-11.525l-23.551-23.551
            C257.045,227.505,253.743,228.441,250.197,228.441z"/>
        <path style="fill:#010002;" d="M266.035,83.082c3.644,3.894,5.918,9.083,5.918,14.821v108.781c0,4.498-1.371,8.686-3.72,12.156
            l23.203,23.203c8.175-9.518,13.152-21.86,13.152-35.359V97.903c0-14.734-5.912-28.104-15.463-37.91L266.035,83.082z"/>
        <path style="fill:#010002;" d="M54.391,43.513c-12.113,0-23.274,4.03-32.324,10.748l23.693,23.693
            c2.649-1.153,5.564-1.806,8.632-1.806h195.806c2.219,0,4.319,0.43,6.337,1.05l24.242-24.242
            c-8.719-5.95-19.249-9.442-30.578-9.442H54.391z"/>
        <path style="fill:#010002;" d="M32.634,206.684V97.903c0-4.96,1.735-9.486,4.542-13.152l-23.16-23.16
            C5.336,71.23,0,83.941,0,97.903v108.781c0,14.109,5.445,26.94,14.288,36.616l23.149-23.149
            C34.478,216.437,32.634,211.792,32.634,206.684z"/>`
};
export const save = {
    viewBox: '0 0 24 24',
    svg: `<path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0
        2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>`
};
export const arrowRight = {
    viewBox: '0 0 24 24',
    svg: `<path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z"/>
      <path fill="none" d="M0,0h24v24H0V0z"/>`
};
export const arrowDown = {
    viewBox: '0 0 24 24',
    svg: `<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
      <path d="M0-.75h24v24H0z" fill="none"/>`
};
export const playerMute = {
    viewBox: '0 0 24 24',
    // tslint:disable-next-line:max-line-length
    svg: `<path d="M12,3.09333333 L12,7.78666667 L9.65333333,5.44 L12,3.09333333 Z M3.41333333,2 L22,20.5866667 L20.5866667,22 L18.2933333,19.7066667 C16.9599933,20.7377829 15.6088957,21.4133317 14.24,21.7333333 L14.24,19.44 C15.1288933,19.1911099 15.9644405,18.7555587 16.7466667,18.1333333 L12,13.4133333 L12,20.9066667 L6.42666667,15.3333333 L2,15.3333333 L2,8.66666667 L7.25333333,8.66666667 L2,3.41333333 L3.41333333,2 Z M19.76,12 C19.76,10.8444387 19.5244468,9.75556067 19.0533333,8.73333333 C18.5822199,7.711106 17.9288931,6.8355592 17.0933333,6.10666667 C16.2577736,5.37777413 15.306672,4.86222373 14.24,4.56 L14.24,2.26666667 C15.7155629,2.58666827 17.0444385,3.21777307 18.2266667,4.16 C19.4088948,5.10222693 20.3288856,6.23999333 20.9866667,7.57333333 C21.6622256,8.96000693 22,10.4355477 22,12 C22,12.8177819 21.9022232,13.6222183 21.7066667,14.4133333 C21.5111101,15.2044484 21.2266685,15.9466632 20.8533333,16.64 L19.2,14.9066667 C19.5733352,13.9644397 19.76,12.9955605 19.76,12 Z M17.0133333,12 C17.0133333,12.3200016 16.9955557,12.5422216 16.96,12.6666667 L14.24,9.97333333 L14.24,7.52 C15.0933376,7.9466688 15.7688864,8.5555516 16.2666667,9.34666667 C16.7644469,10.1377817 17.0133333,11.0222173 17.0133333,12 Z"/>`
};
export const playerPlay = {
    viewBox: '0 0 41.999 41.999',
    svg: `<path d="M36.068,20.176l-29-20C6.761-0.035,6.363-0.057,6.035,0.114C5.706,0.287,5.5,0.627,5.5,0.999v40
        c0,0.372,0.206,0.713,0.535,0.886c0.146,0.076,0.306,0.114,0.465,0.114c0.199,0,0.397-0.06,0.568-0.177l29-20
        c0.271-0.187,0.432-0.494,0.432-0.823S36.338,20.363,36.068,20.176z"/>`
};
export const deleteIcon = {
    viewBox: '0 0 24 24',
    svg: `<path d="M5.14285714,19.6068376 C5.14285714,20.9230769 6.17142857,22 7.42857143,22 L16.5714286,22C17.8285714,
            22 18.8571429,20.9230769 18.8571429,19.6068376 L18.8571429,6.98770443 C18.8571429,6.87648552 18.7695661,
            6.78632479 18.6632734,6.78632479L5.3367266,6.78632479 C5.22965545,6.78632479 5.14285714,6.86819406
            5.14285714,6.98770443 L5.14285714,19.6068376 Z M20,3.70410939 C20,3.42380931 19.7849426,
            3.1965812 19.5095215,3.1965812 L16,3.1965812 L15.2062476,2.36551565 C15.0134424,2.16364693 14.6401138,
            2 14.3500381,2 L9.64996188,2 C9.36989567,2 8.98394775,2.16637949 8.7937524,2.36551565 L8,3.1965812
            L4.49047852,3.1965812 C4.21959471,3.1965812 4,3.41743456 4,3.70410939 L4,5.0822154 C4,5.36251548
            4.22618103,5.58974359 4.4963932,5.58974359 L19.5036068,5.58974359 C19.7777572,5.58974359 20,5.36889022 20,
            5.0822154 L20,3.70410939 Z"></path>`
};
export const add = {
    viewBox: '0 0 24 24',
    svg: `<path d="M11,13 L3,13 L3,11 L11,11 L11,3 L13,3 L13,11 L21,11 L21,13 L13,13 L13,21 L11,21 L11,13 Z"></path>`
};
export const playerVolume = {
    viewBox: '0 0 475.082 475.081',
    svg: `<path d="M200.999,63.952c-4.946,0-9.229,1.812-12.847,5.426l-95.074,95.075H18.276c-4.952,0-9.234,1.812-12.85,5.424
            C1.809,173.493,0,177.778,0,182.726v109.63c0,4.949,1.809,9.233,5.426,12.848c3.619,3.617,7.902,5.427,12.85,
            5.427h74.798l95.074,95.078c3.617,3.61,7.9,5.424,12.847,5.424c4.952,0,9.234-1.813,12.85-5.424c3.617-3.614,
            5.426-7.901,5.426-12.847V82.228
            c0-4.948-1.809-9.234-5.422-12.85C210.23,65.764,205.951,63.952,200.999,63.952z"/>
        <path d="M316.769,277.936c8.093-12.467,12.135-25.93,12.135-40.395s-4.042-27.992-12.135-40.556
            c-8.094-12.562-18.791-21.41-32.121-26.551c-1.902-0.949-4.284-1.427-7.139-1.427c-4.944,0-9.232,1.762-12.847,5.282
            c-3.61,3.521-5.427,7.852-5.427,12.99c0,3.997,1.143,7.376,3.432,10.137c2.283,2.762,5.041,5.142,8.282,7.139
            c3.23,1.998,6.468,4.188,9.708,6.567c3.238,2.38,5.996,5.758,8.278,10.135c2.276,4.38,3.426,9.804,3.426,16.277
            c0,6.471-1.143,11.896-3.426,16.276c-2.282,4.381-5.04,7.755-8.278,10.14c-3.24,2.379-6.478,4.569-9.708,6.567
            c-3.241,1.992-5.999,4.377-8.282,7.132c-2.282,2.765-3.432,6.143-3.432,10.14c0,5.144,1.816,9.47,5.427,12.99
            c3.614,3.521,7.902,5.288,12.847,5.288c2.854,0,5.236-0.479,7.139-1.424C297.978,299.304,308.679,290.403,
            316.769,277.936z"/>
        <path d="M377.728,318.194c16.18-24.646,24.273-51.531,24.273-80.654c0-29.124-8.094-56.005-24.273-80.666
            c-16.177-24.645-37.6-42.583-64.241-53.815c-2.471-0.95-4.948-1.427-7.416-1.427c-4.948,0-9.236,1.809-12.854,5.426
            c-3.613,3.616-5.424,7.898-5.424,12.847c0,7.424,3.713,13.039,11.139,16.849c10.657,5.518,17.888,9.705,21.693,12.559
            c14.089,10.28,25.077,23.173,32.976,38.686c7.898,15.514,11.848,32.026,11.848,49.537c0,17.512-3.949,34.023-11.848,
            49.536c-7.898,15.516-18.894,28.407-32.976,38.684c-3.806,2.857-11.036,7.043-21.693,12.563c-7.426,3.809-11.139,
            9.424-11.139,16.847
            c0,4.948,1.811,9.236,5.424,12.847c3.617,3.621,7.991,5.432,13.131,5.432c2.286,0,4.668-0.483,7.139-1.428
            C340.128,360.783,361.551,342.844,377.728,318.194z"/>
        <path d="M438.824,116.92c-24.171-36.638-56.343-63.622-96.505-80.943c-2.471-0.95-4.948-1.425-7.416-1.425
            c-4.948,0-9.236,1.811-12.847,5.424c-3.621,3.615-5.432,7.902-5.432,12.85c0,6.851,3.714,12.469,11.14,16.846
            c1.335,0.756,3.467,1.755,6.42,2.996c2.95,1.232,5.089,2.231,6.427,2.993c8.754,4.755,16.56,9.611,23.418,14.56
            c23.407,17.318,41.682,38.922,54.816,64.809c13.134,25.885,19.697,53.388,19.697,82.512c0,29.129-6.563,56.626-19.697,
            82.512c-13.131,25.889-31.409,47.496-54.816,64.809c-6.858,4.948-14.664,9.801-23.418,14.562c-1.338,0.756-3.477,
            1.752-6.427,2.99c-2.953,1.232-5.085,2.231-6.42,2.998c-7.426,4.374-11.14,9.993-11.14,16.844c0,4.949,1.811,9.233,
            5.432,12.848c3.61,3.617,7.898,5.427,12.847,5.427c2.468,0,4.945-0.476,7.416-1.431c40.162-17.315,72.334-44.3,
            96.505-80.94c24.174-36.638,36.258-76.849,36.258-120.625S463.001,153.554,438.824,116.92z"/>`
};
export const search = {
    viewBox: '0 0 24 24',
    svg: `<path d="M15.5,14 L14.71,14 L14.43,13.73 C15.41,12.59 16,11.11 16,9.5 C16,5.91 13.09,3 9.5,3 C5.91,3
        3,5.91 3,9.5 C3,13.09 5.91,16 9.5,16 C11.11,16 12.59,15.41 13.73,14.43 L14,14.71 L14,15.5 L19,20.49
        L20.49,19 L15.5,14 L15.5,14 Z M9.5,14 C7.01,14 5,11.99 5,9.5 C5,7.01 7.01,5 9.5,5 C11.99,5 14,7.01 14,9.5
        C14,11.99 11.99,14 9.5,14 L9.5,14 Z"/>`
};
export const upload = {
    viewBox: '0 0 24 24',
    svg: `<path d="M9,16 L15,16 L15,10 L19,10 L12,3 L5,10 L9,10 L9,16 Z M5,18 L19,18 L19,20 L5,20 L5,18 Z"/>`
};
export const calendar = {
    viewBox: '0 0 24 24',
    svg: `<path d="M19,4 L18,4 L18,2 L16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L5,4 C3.89,4 3.01,4.9 3.01,6 L3,20
        C3,21.1 3.89,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 L19,4 Z M19,20
        L5,20 L5,9 L19,9 L19,20 L19,20 Z M7,11 L12,11 L12,16 L7,16 L7,11 Z"/>`
};
//# sourceMappingURL=svgIcons.js.map